<script setup lang="ts">
defineOptions({ name: 'AppFooter' })

// #920: 教室・学校向けの入口。導線は 1 箇所に置かない（#795 は露出 1 箇所で
// prod 30 日 3 件・露出率 2% だった）。ここ / トップ下部 / 料金ページの 3 箇所。
const { trackClassroomCta } = useFunnelEvent()
</script>

<template>
  <div class="footer-area">
    <v-btn
      variant="text"
      href="https://www.samurai-apps.com/"
    >
      <span class="mx-4">&copy;{{ new Date().getFullYear() }}
        <strong>サムライアプス株式会社</strong></span>
    </v-btn>
    <v-btn
      variant="text"
      to="/classroom"
      @click="trackClassroomCta('entry', 'footer')"
    >
      教室・学校の方へ
    </v-btn>
    <v-btn
      variant="text"
      to="/docs/termsofuse"
    >
      利用規約
    </v-btn>
    <v-btn
      variant="text"
      to="/docs/privacypolicy"
    >
      プライバシーポリシー
    </v-btn>
    <v-btn
      variant="text"
      to="/docs/scta"
    >
      特定商取引法に基づく表記
    </v-btn>
  </div>
</template>

<style scoped>
.footer-area {
  background-color: #243447;
  color: #F3EFE6;

  padding: 8px;
  text-align: center;
}

.footer-area .v-btn {
  height: max(20px, calc(2.813 * var(--u)));
  padding: 0 max(5.56px, calc(0.781 * var(--u)));
  font-size: 70%;
}
</style>
